import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';

const ConsultationTypesSection = () => {
  const consultationTypes = [
    {
      title: 'Очная консультация',
      description: 'на базе МАДОУ МО г. Краснодар «Детский сад № 213» по адресу г. Краснодар, ул. им. Тургенева, 185.',
      color: '#00ACC1',
    },
    {
      title: 'Дистанционная консультация',
      description: 'с применением информационно-телекоммуникационных сетей (по видео-конференц-связи) или по телефону +7(918)213-03-33.',
      color: 'transparent',
      outlined: true,
    },
    {
      title: 'Консультация в форме письменного ответа',
      description: 'на запрос родителей (законных представителей) (по электронной почте wonderland_2023@mail.ru, в мессенджеры).',
      color: 'transparent',
      outlined: true,
    },
    {
      title: 'Проведение просветительских мероприятий для родителей',
      description: '(в том числе вебинаров, конференций) с выдачей участникам сертификатов.',
      color: '#81C784',
      gradient: true,
    },
  ];

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: 'white' }} id="consultations">
      <Container maxWidth="xl">
        <Typography
          variant="h3"
          sx={{
            textAlign: 'center',
            mb: 6,
            fontWeight: 700,
            color: '#1a1a1a',
            fontSize: { xs: '1.75rem', md: '2.5rem' }
          }}
        >
          Виды и формы консультационных услуг
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                height: '100%',
                borderRadius: 4,
                backgroundColor: consultationTypes[0].color,
                color: 'white',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
                  {consultationTypes[0].title}
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  {consultationTypes[0].description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card
              sx={{
                height: '100%',
                borderRadius: 4,
                border: '2px solid #00ACC1',
                backgroundColor: 'white',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 700, color: '#00ACC1' }}>
                  {consultationTypes[1].title}
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.primary' }}>
                  {consultationTypes[1].description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card
              sx={{
                height: '100%',
                borderRadius: 4,
                border: '2px solid #81C784',
                backgroundColor: 'white',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 700, color: '#81C784' }}>
                  {consultationTypes[2].title}
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.primary' }}>
                  {consultationTypes[2].description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card
              sx={{
                height: '100%',
                borderRadius: 4,
                background: 'linear-gradient(135deg, #00ACC1 0%, #81C784 50%, #C5E1A5 100%)',
                color: 'white',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
                  {consultationTypes[3].title}
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  {consultationTypes[3].description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ConsultationTypesSection;
